import { useState, useEffect } from "react";
import { useToken } from "./useToken";

export const useUser = () => {
  const [token] = useToken();
  
  const getPayloadFromToken = (token) => {
    if (!token) {
      console.warn('No token provided to getPayloadFromToken');
      return null;
    }

    try {
      // Check if token has the correct JWT format (three parts separated by dots)
      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) {
        console.warn('Invalid JWT token format');
        return null;
      }

      // Clean the token - remove any whitespace or unexpected characters
      const cleanToken = token.trim();
      
      // Get the payload part (second part of JWT)
      const payload = cleanToken.split('.')[1];
      
      if (!payload) {
        console.warn('No payload found in token');
        return null;
      }

      // Base64 decode with proper padding
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
      
      const decodedPayload = atob(paddedBase64);
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      console.error('Token that caused error:', token);
      return null;
    }
  };

  const [user, setUser] = useState(() => {
    if (!token) return null;
    return getPayloadFromToken(token);
  });

  useEffect(() => {
    if (!token) {
      setUser(null);
    } else {
      const payload = getPayloadFromToken(token);
      setUser(payload);
    }
  }, [token]);

  return user;
};